export default __webpack_public_path__ + "static/media/compatible-tiendanube.ea42ba1a.svg";